import styled, { css } from "styled-components";
import { PersonOutline } from "@mui/icons-material";
import { Box } from "@mui/material";

export const HeaderWrapper = styled(Box)<{ $isLandingPage: boolean }>`
	width: 100%;
	position: ${({ $isLandingPage }) => ($isLandingPage ? "absolute" : "fixed")};
	top: var(--sales-banner-height, 0px);
	z-index: 1000;

	a {
		text-decoration: none;
		color: ${({ theme }) => theme.palette.text.primary};
	}

	${({ theme, $isLandingPage }) =>
		!$isLandingPage
			? css`
					background: ${theme.custom_palette.color1};
				`
			: null}
`;

export const StyledPerson = styled(PersonOutline)`
	path {
		fill: ${({ theme }) => theme.palette.text.primary};
	}
`;
